export const COMPANY_VISIBLE_ITEMS = [
  {
    label: '上場情報',
    type: 'listed_phase',
  },
  {
    label: 'URL',
    type: 'official_url',
  },
  {
    label: '業種',
    type: 'industry',
  },
  {
    label: '事業内容',
    type: 'description',
  },

  {
    label: '従業員数',
    type: 'number_of_employees',
  },
  {
    label: '設立年',
    type: 'established_date',
  },
];

export const TAB_ITEMS = [
  {
    label: '企業情報',
    value: 'profile',
  },
  {
    label: 'タイムライン',
    value: 'timeline',
  },
  {
    label: '求人一覧',
    value: 'jobs',
  },
  {
    label: '提案管理',
    value: 'suggestion',
  },
  {
    label: 'マッチング管理',
    value: 'matching',
  },
] as const;

export const COMPANY_SEARCH_ITEMS = [
  {
    label: '事業内容',
    type: 'text',
  },
  {
    label: '所在地',
    type: 'text',
  },
  {
    label: '従業員数',
    type: 'number',
  },
  {
    label: '設立年',
    type: 'number',
  },
];

export const LISTED_PHASE_ITEMS = [
  {
    label: '非上場',
    value: 'unlisted',
  },
  {
    label: 'プライム市場',
    value: 'prime_market',
  },
  {
    label: 'スタンダード市場',
    value: 'standard_market',
  },
  {
    label: 'グロース市場',
    value: 'growth_market',
  },
  {
    label: 'ジャスダック上場',
    value: 'jasdaq',
  },
  {
    label: '不明',
    value: 'unknown',
  },
];

export const COMPANY_PHASE_ITEMS = [
  { label: 'シード', value: 'seed' },
  { label: 'シリーズA', value: 'series_a' },
  { label: 'シリーズB', value: 'series_b' },
  { label: 'シリーズC', value: 'series_c' },
  { label: 'シリーズD', value: 'series_d' },
  { label: 'シリーズE', value: 'series_e' },
  { label: 'シリーズF', value: 'series_f' },
  { label: 'VC', value: 'vc' },
  { label: '上場済み', value: 'listed' },
  { label: '不明', value: 'unknown' },
];

export const COMPANY_ORDER_ITEMS = [
  { value: 'id', label: '登録日順' },
  { value: 'updated_at', label: '最終更新順' },
  { value: 'provided_job_posts_count', label: '求人件数順' },
  { value: 'matched_count', label: 'マッチング件数' },
  { value: 'suggested_job_posts_count', label: '提案数順' },
];

export const COMPANY_JOB_POST_ENDPOINTS_SORT_ITEMS = [
  { value: 'updated_at:desc', label: '更新が新しい順' },
  { value: 'updated_at:asc', label: '更新が古い順' },
  { value: 'created_at:desc', label: '作成が新しい順' },
  { value: 'created_at:asc', label: '作成が古い順' },
];
